var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "figma_5968705 (1) 1",
    clipPath: "url(#clip0_1588_11610)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    transform: "translate(-0.000976562 -6.10352e-05)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.1045 44.9999C45.1045 36.7157 51.8202 30 60.1044 30C68.3887 30 75.1044 36.7159 75.1044 44.9999C75.1044 53.2843 68.3885 59.9999 60.1044 59.9999C51.82 59.9999 45.1045 53.2842 45.1045 44.9999Z",
    fill: "#00BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1045 75C15.1045 66.7158 21.8202 60.0001 30.1044 60.0001L38.0981 55.7797L45.1044 60.0001V75C45.1044 83.2844 38.3887 89.9999 30.1044 89.9999C21.8202 89.9999 15.1045 83.2842 15.1045 75Z",
    fill: "#00CF7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.1046 -6.10352e-05L36.9424 14.1802L45.1046 29.9998H59.8941C68.1785 29.9998 74.8941 23.2841 74.8941 14.9999C74.8941 6.71566 68.1784 -6.10352e-05 59.8941 -6.10352e-05H45.1046Z",
    fill: "#FF7361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.8936 14.9999C14.8936 23.2841 21.6093 29.9998 29.8935 29.9998L37.8506 33.0732L45.1038 29.9998V-6.10352e-05H29.8933C21.6093 -6.10352e-05 14.8936 6.71566 14.8936 14.9999Z",
    fill: "#FF4D12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.1045 44.9999C15.1045 53.2843 21.8202 59.9999 30.1044 59.9999H45.1044V29.9998H30.1044C21.8202 29.9998 15.1045 36.7157 15.1045 44.9999Z",
    fill: "#B659FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1588_11610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(-0.000976562 -6.10352e-05)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.fa2d28d2a3dc356cad908b9fa0c8b0a8.svg";
export { ForwardRef as ReactComponent };